<template>
  <b-form-group
    label="Kategori"
    label-for="categories"
  >
    <v-select
      id="id_categories"
      v-model="dataItem.id_categories"
      label="title"
      :options="categories"
      :reduce="category => category.id"
      placeholder="Seçiniz"
      @input="getProducts"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'CategoriesNotificationsCard',
  components: {
    BFormGroup,
    vSelect,
  },
  data() {
    return {
      locale: 'tr',
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['notifications/dataItem']
    },
    categories() {
      return this.$store.getters['categories/dataList']
    },
  },
  created() {
    this.getCategories()
  },
  methods: {
    getCategories() {
      this.$store.dispatch('categories/getDataList', {
        select: ['categories.id AS id', 'categories.title AS title'],
      })
    },
    getProducts() {
      this.$store.commit('products/SET_DATA_LIST', [])
      this.dataItem.id_products = null
      if (this.dataItem.id_categories) {
        this.$store.dispatch('products/getDataList', {
          select: ['products.id AS id', 'products.title AS title'],
          where: {
            'products.id_categories': this.dataItem.id_categories,
          },
          onlyList: true,
        })
      }
    },
  },
}
</script>
